const mensajesLog = {
    CargarArchivosEntro: "El usuario entró a la sección de Cargar archivos.",
    CargarArchivosEnvio: "El usuario envió el o los siguientes archivos.",   
    CargarArchivosEnvioError: "Error al enviar los siguientes archivos",
    ConsultarEstatusEntro: "El usuario entró a la sección de estatus de archivos.",
    ConsultarEstatusDescargoLogs: "El usuario descargó el siguiente archivo de log ",
    ConsultarPlantillasEntro: "El usuario entró a la sección de plantillas.",
    ConsultarPlantillasDescarga: "El usuario descargó la siguiente plantilla.",
    ConsultarGEOBIN: "El usuario intentó consultar el sistema GEOBIN .",
    ErrorAccesoSNII: "El siguiente usuario intentó entrar a SNII, pero se le negó el acceso porque el token no es válido o ha expirado."
  };
    
  
  export default mensajesLog;